import React, { memo } from 'react';
export function ProblemSection() {
  return <section className="bg-[#1a1a2e] text-white py-10 md:py-14 px-4" data-id="element-124">
      <div className="max-w-3xl mx-auto text-center" data-id="element-125">
        <h2 className="text-2xl md:text-4xl font-black mb-4 font-['Oswald'] uppercase" data-id="element-126">
          🧠 ¿Tu hijo no para de hacer preguntas?
        </h2>

        <div className="max-w-lg mx-auto space-y-3 mb-6" data-id="element-127">
          <p className="text-lg text-blue-200 italic" data-id="element-128">
            "¿Cómo funciona el corazón?"
          </p>
          <p className="text-lg text-blue-200 italic" data-id="element-129">"¿Por qué respiramos?"</p>
          <p className="text-lg text-blue-200 italic" data-id="element-130">
            "¿Qué hay dentro del cuerpo?"
          </p>
        </div>

        <p className="text-xl text-yellow-400 font-bold mb-6" data-id="element-131">
          👉 No es curiosidad… es inteligencia despertando.
        </p>

        <div className="bg-white/10 rounded-xl p-6 max-w-lg mx-auto" data-id="element-132">
          <p className="text-base text-gray-300 mb-2" data-id="element-133">
            Pero aquí está el problema:
          </p>
          <p className="text-lg text-white font-bold" data-id="element-134">
            La mayoría de los niños terminan memorizando sin entender.
          </p>
          <p className="text-base text-red-300 mt-2" data-id="element-135">
            Y cuando no entienden… pierden el interés.
          </p>
        </div>
      </div>
    </section>;
}